<template>
  <div class="list" :style="{ paddingTop: isExport ? '48px' : 0 }">
    <div v-if="isExport" class="export">
      <a-checkbox v-model="selectAll" @change="changeSelect"
        >全选本页记录</a-checkbox
      >
      <div class="detail">
        <div class="num">当前选中{{ exportNum }}条记录</div>
        <a-button
          size="small"
          @click="handleExportAll"
          shape="round"
          type="primary"
          >确认导出</a-button
        >
      </div>
    </div>
    <div v-for="(item, index) in list" :key="index" class="list-cell">
      <a-checkbox
        style="margin-top: 6px;margin-right: 10px;"
        @click="
          (e) => {
            e.stopPropagation();
          }
        "
        :checked="item.checked"
        @change="changeSelect2(index)"
        v-if="isExport"
      >
      </a-checkbox>
      <div class="avatar">
        <a-avatar
          :size="36"
          :src="
            item.type == 'record'
              ? require('@/assets/director/director-03.png')
              : require('@/assets/director/director-04.png')
          "
        />
      </div>
      <div class="msg">
        <div class="header">
          <div
            @click="select(index)"
            class="flex-row"
            style="margin-right: auto;"
          >
            <div class="teacher">
              {{ item.teacher_name }}
            </div>
            <div class="action">
              为
            </div>
            <div class="students">
              {{
                item.data.students.length == 0
                  ? ""
                  : item.data.students.length < 3
                  ? item.data.students.map((item) => item.name).join("、")
                  : item.data.students[0].name +
                    "、" +
                    item.data.students[0].name +
                    "等" +
                    item.data.students.length +
                    "人"
              }}
            </div>

            <div class="info">
              发布{{ item.type == "notable" ? "快速记" : "观察记录表" }}
            </div>
            <div class="time">
              {{ item.data.record_time }}
            </div>
            <div v-show="item.data.sync_parent" class="status">
              已同步
            </div>
          </div>

          <a-dropdown placement="bottomRight" :trigger="['click']">
            <a-menu slot="overlay" placement="bottom">
              <a-menu-item @click="handleEdit(item)" key="1"> 编辑</a-menu-item>
              <a-menu-item @click="handleDel(item.id)" key="2">
                删除
              </a-menu-item>
              <a-menu-item @click="handleExport(item)" key="3">
                导出</a-menu-item
              >
              <a-menu-item
                @click.stop="$router.push('/observe/addTask')"
                key="4"
              >
                评论</a-menu-item
              >
              <a-menu-item
                @click.stop="$router.push('/observe/addTask')"
                key="5"
              >
                加入成长册</a-menu-item
              >
            </a-menu>
            <a-icon type="ellipsis" />
          </a-dropdown>
        </div>
        <div
          v-if="item.type == 'notable'"
          @click="select(index)"
          class="content"
        >
          {{ item.record_text }}
        </div>
        <div v-if="item.type == 'notable'">
          <file-list :files="item.recordAtt"></file-list>
        </div>

        <div v-if="item.type == 'record'" class="form-type">
          <section class="form-table">
            <div class="form-title">观察记录表</div>
            <div class="line">
              <div class="label border-left">记录教师</div>
              <div class="info">{{ item.teacher_name }}</div>
            </div>
            <div class="line" style="padding-bottom: 10px;">
              <div class="label">观察对象</div>
              <div class="info">
                {{ item.data.students.map((item) => item.name).join("、") }}
              </div>
            </div>
            <div @click="select(index)" class="look">查看详情</div>
          </section>
        </div>
      </div>
    </div>

    <a-empty
      style="margin-top: 60px;"
      v-show="list.length == 0 && !loading"
    ></a-empty>
    <a-spin v-if="loading" :spinning="loading">
      <div style="width: 100%;height: 100px;"></div>
    </a-spin>
    <a-drawer
      wrapClassName="drawer-style"
      :visible="showModal"
      :title="false"
      placement="right"
      width="800px"
      :closable="false"
      :get-container="false"
      @close="showModal = false"
      :bodyStyle="{
        padding: '0',
      }"
    >
      <div v-if="currentObserve" class="drawer-content">
        <div class="head flex-row">
          <a-icon
            @click="showModal = false"
            style="color: #999;margin-right: 8px;cursor: pointer;font-size: 14px;"
            type="close"
          />
          <div class="title">
            {{
              currentObserve
                ? currentObserve.type != "record"
                  ? "观察快速记"
                  : "观察记录表"
                : ""
            }}
          </div>
          <a-space class="right">
            <a-button @click="handleDel(currentObserve.id)" size="small">删除</a-button>
            <a-button @click="handleExport(currentObserve)" size="small"
              >导出</a-button
            >
            <a-button @click="handleEdit(false)" size="small" type="primary"
              >编辑</a-button
            >
          </a-space>
        </div>

        <div v-if="currentObserve.type == 'notable'" class="record">
          <div class="teacher flex-row">
            <a-avatar :size="36" icon="user"></a-avatar>
            <div class="left">
              <div class="name">{{ currentObserve.teacher_name }}</div>
              <div class="flex-row">
                <div class="school">{{ currentObserve.school_name }}</div>
                <div class="time">{{ currentObserve.record_time }} 记录</div>
              </div>
            </div>
          </div>

          <div class="content">{{ currentObserve.record_text }}</div>
          <div style="padding:0 15px;margin-bottom: 15px;">
            <file-list :files="currentObserve.recordAtt"></file-list>
          </div>
          <div class="split"></div>
          <section class="card">
            <div class="sub-title">记录中的孩子</div>
            <div class="names">
              {{ currentObserve.students.map((item) => item.name).join("、") }}
            </div>
          </section>
          <div class="split"></div>
          <section class="card">
            <div class="sub-title">观察领域</div>
            <div class="names">
              {{
                currentObserve.fields
                  .map((item) => item.field_name + ">" + item.target_name)
                  .join("、")
              }}
            </div>
          </section>
          <div class="split"></div>
          <section class="card">
            <div class="sub-title">行为表现</div>
            <div class="behavior">
              <bea-list
                :showAction="false"
                :list="currentObserve.target2"
                backgroundColor="#fff"
              ></bea-list>
            </div>
          </section>

          <div class="split"></div>
          <section class="card">
            <div class="sub-title">将记录同步给家长</div>
            <div class="flex-row">
              <div class="status">
                {{ currentObserve.sync_parent ? "已同步" : "未同步" }}
              </div>
              <a-button v-if="!currentObserve.sync_parent" @click="handleSyncNotable(currentObserve.id)" size="small" shape="round">点击同步</a-button>
              <a-icon
                v-else
                type="check-circle"
                :style="{
                  color: currentObserve.sync_parent ? '#76B7DF' : '#ccc',
                }"
                style="font-size: 16px;margin-left: 8px;"
              />
            </div>
          </section>
        </div>

        <!--记录表-->
        <div v-else class="form">
          <div
            class="teacher flex-row"
            style="border-bottom: none;margin-top: 0px;"
          >
            <a-avatar :size="36" icon="user"></a-avatar>
            <div class="left">
              <div class="name">
                {{ currentObserve.teacher_name || "未知" }}
              </div>
              <div class="flex-row" style="justify-content: flex-start;">
                <div class="school">
                  {{ currentObserve.school_name || "未知学校" }}
                </div>
                <div class="time" style="margin-left: 10px;">
                  {{ currentObserve.record_time }} 记录
                </div>
              </div>
            </div>
          </div>

          <section class="form-table">
            <div class="form-title">观察记录表</div>
            <div class="line">
              <div class="label">记录时间</div>
              <div class="info">{{ currentObserve.record_time }}</div>
              <div class="label border-left">记录教师</div>
              <div class="info">
                {{ currentObserve.teacher_name || "未知" }}
              </div>
            </div>
            <div class="line">
              <div class="label">观察对象</div>
              <div class="info">
                {{
                  currentObserve.students.map((item) => item.name).join("、")
                }}
              </div>
            </div>
            <div class="line">
              <div class="label">观察场景</div>
              <div class="info">
                {{ currentObserve.scenes.map((item) => item.name).join("、") }}
              </div>
            </div>
            <div
              v-for="(record, index) in currentObserve.recordTextDetail"
              class="line"
            >
              <div class="label">观察实录</div>
              <div class="info">
                <div class="content">{{ record.record_text }}</div>
                <file-list :files="record.recordAtt"></file-list>
              </div>
            </div>

            <div class="line">
              <div class="label">关联活动</div>
              <div class="info">
                {{
                  currentObserve.obserAct.map((item) => item.name).join("、")
                }}
              </div>
            </div>

            <div class="line">
              <div class="label">关联领域</div>
              <div class="info">
                {{
                  currentObserve.fields
                    .map((item) => item.field_name + ">" + item.target_name)
                    .join("、")
                }}
              </div>
            </div>
            <div class="line">
              <div class="label">行为表现</div>
              <div class="info">
                <bea-list
                  :showAction="false"
                  :list="currentObserve.target2"
                  backgroundColor="#fff"
                ></bea-list>
              </div>
            </div>
            <div class="line">
              <div class="label">观察分析</div>
              <div class="info">
                <div class="content">{{ currentObserve.analysis }}</div>
                <file-list :files="currentObserve.analysisAtt"></file-list>
              </div>
            </div>
            <div class="line">
              <div class="label">回应策略</div>
              <div class="info">
                <div class="content">
                  {{ currentObserve.strategy }}
                </div>
                <file-list :files="currentObserve.strategyAtt"></file-list>
              </div>
            </div>
            <div class="line">
              <div class="label">家庭指导</div>
              <div class="info">
                <div class="content">{{ currentObserve.guidance }}</div>
                <file-list :files="currentObserve.guidanceAtt"></file-list>
              </div>
            </div>
          </section>
          <section class="card">
            <div class="sub-title">将记录同步给家长</div>
            <div class="flex-row" style="justify-content: space-between;">
              <div class="status" style="color: #888;">{{ currentObserve.sync_parent ? "已同步" : "未同步"}}</div>
              <a-button v-if="!currentObserve.sync_parent" @click="handleSyncObserve(currentObserve.id)" size="small" shape="round">点击同步</a-button>
              <a-icon
                v-else
                type="check-circle"
                :style="{
                  color: currentObserve.sync_parent ? '#76B7DF' : '#ccc',
                }"
                style="font-size: 16px;margin-left: 8px;"
              />
            </div>
          </section>
        </div>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import _ from "lodash";
import beaList from "./bea-list-add.vue";
import axios from "axios";
import { leaderApi as directorTestApi } from "../../api/api-director";
import { mapState } from "vuex";
import qs from "qs";
import fileList from "./fileList.vue";
import {
  exportWord,
  getBase64Sync,
  recordImg,
  videoImg,
} from "../../js/export-word";
import { Modal } from "ant-design-vue";

export default {
  data() {
    return {
      selectIndex: 0,
      showModal: false,
      currentObserve: null,
      selectAll: false,
      list: [],
    };
  },
  props: {
    isExport: false,
    value: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value() {
      this.list = _.cloneDeep(this.value);
    },
    showModal() {
      if (!this.showModal) {
        this.$emit("close");
      }
    },
  },
  components: {
    beaList,
    fileList,
  },
  computed: {
    exportNum() {
      return this.list.filter((item) => item.checked).length;
    },
    ...mapState(["userInfo"]),
  },

  methods: {
    handleSyncObserve(id) {
      Modal.confirm({
        title: "提示",
        content: "是否同步到家长端",
        okText: "确定",
        centered: true,
        cancelText: "取消",
        onOk: () => {
          axios({
            url: directorTestApi.main + directorTestApi.saveSyncParentObserObserve,
            method: "POST",
            data: qs.stringify({
              id: id,
              leader_id: this.userInfo.id,
            }),
          }).then((res) => {
            if (res.data.result) {
              this.$message.success("同步成功");
              this.currentObserve.sync_parent = true;
            }
          })
        }
      })
    },
    handleSyncNotable(id) {
      Modal.confirm({
        title: "提示",
        content: "是否同步到家长端",
        okText: "确定",
        centered: true,
        cancelText: "取消",
        onOk: () => {
          axios({
            url: directorTestApi.main + directorTestApi.saveSyncParentObserNotable,
            method: "POST",
            data: qs.stringify({
              id: id,
              leader_id: this.userInfo.id,
            }),
          }).then((res) => {
            if (res.data.result) {
              this.$message.success("同步成功");
              this.currentObserve.sync_parent = true;
            }
          })
        }
      })
      
    },
    handleExportAll() {
      if (this.exportNum == 0) {
        this.$message.warning("请选择需要导出的记录");
        return;
      }
      this.$confirm({
        title: "提示",
        content: "导出过程需要一点时间，请耐心等待，点击确定开始导出",
        okText: "确定",
        centered: true,
        cancelText: "取消",
        onOk: () => {
          this.handleExportAll2();
        },
        onCancel: () => {},
      });
    },
    handleExportAll2() {
      this.$message.loading({
        content: "正在导出...",
        key: "loading",
      });
      let list = this.list.filter((item) => item.checked);
      axios({
        url: directorTestApi.main + directorTestApi.getObserAllDetail,
        method: "POST",
        data: qs.stringify({
          id: list.map((item) => item.id).join(","),
          leader_id: this.userInfo.id,
        }),
      })
        .then(async (res) => {
          if (res.data.result) {
            let objs = res.data.data;
            let data = [];

            for (let i = 0; i < objs.length; i++) {
              const item = objs[i];
              let obj = null;
              if (item.type == "record") {
                const objItem = await this.filterRecordObj(item.data);
                data.push({
                  record: [objItem],
                  notable: [],
                  isRecord: true,
                  isNotable: false,
                });
              } else {
                const objItem = await this.filterNotableObj(item.data);
                data.push({
                  notable: [objItem],
                  record: [],
                  isRecord: false,
                  isNotable: true,
                });
              }
            }

            let imgSize = {
              //控制导出的word图片大小
            };
            console.log(data);
            await exportWord(
              "/doc/observe2.docx",
              { data: data },
              "观察记录批量导出" + ".docx",
              imgSize
            );

            this.$message.success({
              content: "导出成功",
              key: "loading",
            });
          } else {
            this.$message.error({
              content: "请求数据失败",
              key: "loading",
            });
          }
        })
        .catch((err) => {
          this.$message.error({
            content: "导出失败",
          });
          console.log(err);
        });
    },
    handleEdit(item) {
      if (item) {
        this.$router.push({
          path: "/director/observe/add",
          query: {
            id: item.id,
            type: item.type,
          },
        });
        return;
      }
      this.$router.push({
        path: "/director/observe/add",
        query: {
          id: this.currentObserve.id,
          type: this.currentObserve.type,
        },
      });
    },
    changeSelect(e) {
      if (this.selectAll) {
        this.list.forEach((item) => {
          item.checked = true;
        });
      } else {
        this.list.forEach((item) => {
          item.checked = false;
        });
      }
      //强制更新
      this.$emit("input", this.list);
    },
    changeSelect2(index) {
      this.$set(this.list[index], "checked", !this.list[index].checked);
      this.$forceUpdate();
      this.$emit("input", this.list);
    },
    select(index) {
      this.selectIndex = index;
      this.getDetail(this.list[index].id, this.list[index].type);
    },
    getDetail(id, type) {
      this.$message.loading({
        content: "正在获取详情...",
        key: "loading",
      });
      axios({
        url:
          type == "record"
            ? directorTestApi.main + directorTestApi.getObserRecordDetail
            : directorTestApi.main + directorTestApi.getObserNotableDetail,
        method: "POST",
        data: qs.stringify({
          id,
          leader_id: this.userInfo.id,
          school_id: this.userInfo.school_id || "",
        }),
      }).then((res) => {
        if (res.data.result) {
          this.$message.success({
            content: "加载成功",
            key: "loading",
            duration: 0.5,
          });
          this.currentObserve = res.data.data;
          this.showModal = true;
          this.currentObserve.type = type;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    loadMore() {
      this.$emit("load");
    },
    async exportNotable(obj) {
      await this.filterAtt(obj.recordAtt);
      const wordData = {
        record_time: obj.record_time,
        teacher_name: obj.teacher_name,
        students_name: obj.students.map((item) => item.name).join("、"),
        record_text: obj.record_text,
        recordAtt: obj.recordAtt,
        range_name: obj.fields
          .map((item) => item.field_name + ">" + item.target_name)
          .join("、"),
        target2: obj.target2,
      };
      let imgSize = {
        //控制导出的word图片大小
        imgUrl: [160, 160],
      };
      await exportWord(
        "/doc/notable2.docx",
        { notable: [wordData], record: [] },
        "快速记" + ".docx",
        imgSize
      );
    },
    async filterAtt(att) {
      for (const i in att) {
        const file = att[i];
        if (file.type == "pic") {
          att[i].imgUrl = await getBase64Sync(file.url);
        } else if (file.type == "record") {
          if (file.qrcode) {
            att[i].imgUrl = await getBase64Sync(file.qrcode);
          } else {
            att[i].imgUrl = recordImg;
          }
        } else if (file.type == "video") {
          if (file.qrcode) {
            att[i].imgUrl = await getBase64Sync(file.qrcode);
          } else {
            att[i].imgUrl = videoImg;
          }
        }
      }
      return true;
    },
    async filterNotableObj(obj) {
      await this.filterAtt(obj.recordAtt);
      const data = {
        record_time: obj.record_time,
        teacher_name: obj.teacher_name,
        students_name: obj.students.map((item) => item.name).join("、"),
        record_text: obj.record_text,
        recordAtt: obj.recordAtt,
        range_name: obj.fields
          .map((item) => item.field_name + ">" + item.target_name)
          .join("、"),
        target2: obj.target2,
      };
      return data;
    },
    async filterRecordObj(obj) {
      await this.filterAtt(obj.analysisAtt);
      await this.filterAtt(obj.guidanceAtt);
      await this.filterAtt(obj.strategyAtt);

      for (let i = 0; i < obj.recordTextDetail.length; i++) {
        const element = obj.recordTextDetail[i];
        for (let m = 0; m < element.recordAtt.length; m++) {
          const att = element.recordAtt[m];
          const file = att;
          if (att.type == "pic") {
            att.imgUrl = await getBase64Sync(att.url);
          } else if (att.type == "record") {
            if (file.qrcode) {
              att.imgUrl = await getBase64Sync(file.qrcode);
            } else {
              att.imgUrl = recordImg;
            }
          } else if (att.type == "video") {
            if (file.qrcode) {
              att.imgUrl = await getBase64Sync(file.qrcode);
            } else {
              att.imgUrl = videoImg;
            }
          }
        }
      }

      const data = {
        record_time: obj.record_time,
        teacher_name: obj.teacher_name,
        students_name: obj.students.map((item) => item.name).join("、"),
        scenes_name: obj.scenes.map((item) => item.name).join("、"),
        recordTextDetail: obj.recordTextDetail,
        obserAct_name: obj.obserAct.map((item) => item.name).join("、"),
        range_name: obj.fields
          .map((item) => item.field_name + ">" + item.target_name)
          .join("、"),
        analysis: obj.analysis,
        analysisAtt: obj.analysisAtt,
        strategy: obj.strategy,
        strategyAtt: obj.strategyAtt,
        guidance: obj.guidance,
        guidanceAtt: obj.guidanceAtt,
        target2: obj.target2,
      };

      return data;
    },
    async exportRecord(obj) {
      await this.filterAtt(obj.analysisAtt);
      await this.filterAtt(obj.guidanceAtt);
      await this.filterAtt(obj.strategyAtt);

      for (let i = 0; i < obj.recordTextDetail.length; i++) {
        const element = obj.recordTextDetail[i];
        for (let m = 0; m < element.recordAtt.length; m++) {
          const att = element.recordAtt[m];
          if (att.type == "pic") {
            att.imgUrl = await getBase64Sync(att.url);
          } else if (att.type == "record") {
            if (att.qrcode) {
              att.imgUrl = await getBase64Sync(att.qrcode);
            } else {
              att.imgUrl = recordImg;
            }
          } else if (att.type == "video") {
            if (att.qrcode) {
              att.imgUrl = await getBase64Sync(att.qrcode);
            } else {
              att.imgUrl = videoImg;
            }
          }
        }
      }

      const wordData = {
        record_time: obj.record_time,
        teacher_name: obj.teacher_name,
        students_name: obj.students.map((item) => item.name).join("、"),
        scenes_name: obj.scenes.map((item) => item.name).join("、"),
        recordTextDetail: obj.recordTextDetail,
        obserAct_name: obj.obserAct.map((item) => item.name).join("、"),
        range_name: obj.fields
          .map((item) => item.field_name + ">" + item.target_name)
          .join("、"),
        analysis: obj.analysis,
        analysisAtt: obj.analysisAtt,
        strategy: obj.strategy,
        strategyAtt: obj.strategyAtt,
        guidance: obj.guidance,
        guidanceAtt: obj.guidanceAtt,
        target2: obj.target2,
      };
      let imgSize = {
        //控制导出的word图片大小
        imgUrl: [160, 160],
      };
      await exportWord(
        "/doc/temp2.docx",
        { data: [wordData] },
        "观察记录表_" + obj.id + ".docx",
        imgSize
      );
    },
    handleExport(obj) {
      this.$confirm({
        title: "提示",
        content: "导出过程需要一点时间，请耐心等待，点击确定开始导出",
        okText: "确定",
        centered: true,
        cancelText: "取消",
        onOk: () => {
          if (obj.type == "record") {
            this.exportRecord(obj);
          } else {
            this.exportNotable(obj);
          }
        },
        onCancel: () => {},
      });
    },
    handleDel(id) {
      this.$confirm({
        title: "提示",
        content: "确定删除吗？",
        okText: "确定",
        centered: true,
        cancelText: "取消",
        onOk: () => {
          axios({
            url: directorTestApi.main + directorTestApi.delObserAll,
            method: "POST",
            data: qs.stringify({
              id: id ? id : this.list[this.selectIndex].id,
              leader_id: this.userInfo.id,
            }),
          }).then((res) => {
            if (res.data.result) {
              this.list.splice(this.selectIndex, 1);
              this.showModal = false;
              this.selectIndex = -1;
              this.currentObserve = null;
              this.$message.success("删除成功");
            } else {
              this.$message.error(res.data.message);
            }
          });
        },
        onCancel: () => {},
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.split {
  height: 10px;
  background: #f1f1f1;
}

.drawer-content {
  .head {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    padding: 15px;
    .title {
      flex: 1;
      text-align: left;
      margin-left: 2px;
      font-size: 16px;
      font-family: "微软雅黑";
      font-weight: bold;
      //字体平滑
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
  }

  .teacher {
    padding: 15px;
    border-bottom: 1px solid #ececec;
    .left {
      flex-direction: column;
      align-items: flex-start;
      font-size: 12px;
      color: #6a6a6a;
      margin-left: 10px;
      .name {
        font-size: 14px;
        font-weight: 600;
        color: #101010;
      }
    }
    .flex-row {
      justify-content: space-between;
      width: 100%;
      font-size: 12px;
    }
  }

  .content {
    padding: 15px 15px 0 15px;
  }
}
.list {
  padding: 0 15px;
  position: relative;
}
.list-cell {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  margin: 10px 0 30px 0;
  .avatar {
    width: 36px;
    height: 36px;
    margin-right: 10px;
  }
  .msg {
    flex: 1;
    display: flex;
    flex-direction: column;
    .header {
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 14px;
      color: #101010;
      cursor: pointer;
      .teacher {
        font-weight: bold;
        font-size: 14px;
      }

      .students {
        font-weight: bold;
      }

      .action {
        margin: 0 6px;
      }

      .info {
        margin-left: 10px;
      }

      .time {
        margin: 0 10px;
      }

      .status {
        color: #519fd3;
      }
    }

    .content {
      margin-top: 6px;
      color: #6a6a6a;
      cursor: pointer;
    }
  }
}

.file {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: 10px;
  .item {
    width: 20%;
    display: block;
    padding-bottom: 20%;
    background: #eee;
    overflow: hidden;
    border-radius: 5px;
    cursor: pointer;
  }
}

.card {
  padding: 15px;
  .sub-title {
    font-size: 14px;
    font-weight: 500;
    color: #101010;
  }

  .status {
    color: #519fd3;
  }
  .names {
    color: #666;
    margin-top: 4px;
  }
}

.export {
  height: 48px;
  display: flex;
  padding: 0 15px;
  background: #fff;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;

  .detail {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    .num {
      margin-right: 10px;
      color: #75828a;
    }
  }
}

.form-table {
  border: 1px solid #dedede;
  margin: 15px;
  border-radius: 3px;
  .form-title {
    min-height: 40px;
    text-align: center;
    font-weight: bold;
    font-size: 13px;
    color: #101010;
    letter-spacing: 2px;
    width: 100%;
    line-height: 40px;
    margin: 0 auto;
    background: #f1f8Fd;
  }
  .line {
    border-top: 1px solid #dedede;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    box-sizing: border-box;
    font-size: 12px;
    .label {
      min-height: 30px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      width: 100px;
      color: #101010;
      font-weight: bold;
      padding: 5px;
    }
    .border-left {
      border-left: 1px solid #dedede;
    }
    .info {
      border-left: 1px solid #dedede;
      color: #444;
      flex: 1;
      padding: 5px;
      min-height: 28px;

      .content {
        padding: 0;
      }

      .file {
        padding: 0;

        .item {
          position: relative;
          margin-right: 10px;
          video {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            object-fit: fill;
          }

          audio {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            object-fit: contain;
          }
        }
      }
    }
  }
}

.form-type {
  width: 500px;
  position: relative;

  .look {
    height: 45px;
    //背景透明渐变
    background: linear-gradient(to top, #fff, #fff, transparent);
    bottom: 16px;
    left: 16px;
    right: 16px;
    position: absolute;
    z-index: 1;
    padding-top: 5px;
    text-align: center;
    line-height: 40px;
    color: #519fd3;
    cursor: pointer;
  }
  .line {
    .label {
      min-height: 40px;
      line-height: 40px;
    }
    .info {
      min-height: 40px;
      line-height: 40px;
    }
  }
}
</style>
